import { createFileRoute } from "@tanstack/react-router";
import { CityHub } from "./kopa-och-salja.index";

const TITLE = "Comprar y vender de segunda mano en tu ciudad | Sellavo";
const DESCRIPTION =
  "Descubre cómo comprar y vender de segunda mano donde vives, con consejos locales de recogida, envío y qué se vende mejor.";

export const Route = createFileRoute("/es/comprar-y-vender")({
  loader: async () => {
    const { CITIES } = await import("@/lib/orter-seo");
    return { cities: CITIES.map((c) => ({ slug: c.slug, name: c.name })) };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/comprar-y-vender" }],
  }),
  component: CityHub,
});
